export default __webpack_public_path__ + "static/media/RecordFileNotFound.477ad505.gif";